import { htmls } from "../../constants";

const publicAsset = (path) =>
  `${(process.env.PUBLIC_URL || "").replace(/\/$/, "")}/${path}`;

const IMAGE_ASSETS = {
  careduraSquare: publicAsset("caredura/square.png"),
  painfinSquare: publicAsset("painfin/square.png"),
};

const HTML_ASSETS = {
  primera300x250: htmls.PrimeraReactAddWithoutCTA,
};

export const getCreativeImage = (key) => IMAGE_ASSETS[key] || "";

export const getCreativeHtml = (key) => HTML_ASSETS[key] || "";
